import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the MagacinpopisPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-magacinpopis',
  templateUrl: 'magacinpopis.html',
})
export class MagacinpopisPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MagacinpopisPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/magacin/magacinpopis/magacinpopis.ts